<template>
  <v-card min-width="21vw" light outlined>
    <v-card-title class="text-center" style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>Show Coupon Link</h2></v-list-item-title>
        <v-spacer/>
        <v-icon class="icon" @click="close">fa-times</v-icon>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <h4 class="text-center">Links for referral are:</h4>
      <p class="text-center">https://app.swiset.com/register/{{ coupon.couponName }}</p>
      <v-btn @click="close">Close</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ShowCouponLink",
  props: {
    coupon: Object,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
